import { render, staticRenderFns } from "./CookiesTestWebscript.vue?vue&type=template&id=23d250e8&scoped=true&"
import script from "./CookiesTestWebscript.vue?vue&type=script&lang=js&"
export * from "./CookiesTestWebscript.vue?vue&type=script&lang=js&"
import style1 from "./CookiesTestWebscript.vue?vue&type=style&index=1&id=23d250e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d250e8",
  null
  
)

export default component.exports